import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { PopupProvider } from "./context/PopupContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import LpHeader from "./components/LpHeader";
import Footer from "./components/Footer";
import MetaFooter from "./components/MetaFooter";
import PopupForm from "./components/PopupForm";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LandingPage from "./pages/LandingPage";
import ServicePage from "./pages/ServicePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
// import ApplicationPage from "./pages/ApplicationPage";

function Layout() {
  const location = useLocation();
  const isLp = location.pathname === "/lp" || location.pathname === "/lp/";
  const isApp = location.pathname.startsWith("/application");

  return (
    <>
      <ScrollToTop />
      {!isApp && (isLp ? <LpHeader /> : <Header />)}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/lp" element={<LandingPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        {/* <Route path="/application/main" element={<ApplicationPage />} /> */}
      </Routes>
      {!isApp && (isLp ? <Footer /> : <MetaFooter />)}
      <PopupForm />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PopupProvider>
          <Layout />
        </PopupProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
